export default {
  languages: [],
  defaults_languages: [
    {
      "label": "Akan",
      "value": "Akan"
    },
    {
      "label": "Alemão",
      "value": "Alemão"
    },
    {
      "label": "Amárica",
      "value": "Amárica"
    },
    {
      "label": "Árabe",
      "value": "Árabe",
    },
    {
      "label": "Assamês",
      "value": "Assamês"
    },
    {
      "label": "Awadhi",
      "value": "Awadhi"
    },
    {
      "label": "Azeri",
      "value": "Azeri",
    },
    {
      "label": "Balúchi",
      "value": "Balúchi"
    },
    {
      "label": "Bengali",
      "value": "Bengali",
    },
    {
      "label": "Bhojpuri",
      "value": "Bhojpuri",
    },
    {
      "label": "Bielorrusso",
      "value": "Bielorrusso",
    },
    {
      "label": "Birmanês",
      "value": "Birmanês"
    },
    {
      "label": "Canarês",
      "value": "Canarês"
    },
    {
      "label": "Cazaque",
      "value": "Cazaque",
    },
    {
      "label": "Cebuano",
      "value": "Cebuano",
    },
    {
      "label": "Chatgaya",
      "value": "Chatgaya"
    },
    {
      "label": "Chhattisgarhi",
      "value": "Chhattisgarhi"
    },
    {
      "label": "Chona",
      "value": "Chona",
    },
    {
      "label": "Cingalês",
      "value": "Cingalês",
    },
    {
      "label": "Cinianja",
      "value": "Cinianja"
    },
    {
      "label": "Concani",
      "value": "Concani",
    },
    {
      "label": "Coreano",
      "value": "Coreano",
    },
    {
      "label": "Crioulo haitiano",
      "value": "Crioulo haitiano",
    },
    {
      "label": "Curdo",
      "value": "Curdo",
    },
    {
      "label": "Deccani",
      "value": "Deccani",
    },
    {
      "label": "Dhundhari",
      "value": "Dhundhari",
    },
    {
      "label": "Espanhol",
      "value": "Espanhol"
    },
    {
      "label": "Francês",
      "value": "Francês",
    },
    {
      "label": "Fulani",
      "value": "Fulani",
    },
    {
      "label": "Gan",
      "value": "Gan",
    },
    {
      "label": "Grego",
      "value": "Grego",
    },
    {
      "label": "Guzerate",
      "value": "Guzerate",
    },
    {
      "label": "Hakka",
      "value": "Hakka",
    },
    {
      "label": "Hariani",
      "value": "Hariani"
    },
    {
      "label": "Haúça",
      "value": "Haúça",
    },
    {
      "label": "Hiligaynon",
      "value": "Hiligaynon",
    },
    {
      "label": "Hindi",
      "value": "Hindi",
    },
    {
      "label": "Hmong",
      "value": "Hmong",
    },
    {
      "label": "Holandês",
      "value": "Holandês",
    },
    {
      "label": "Húngaro",
      "value": "Húngaro",
    },
    {
      "label": "Igbo",
      "value": "Igbo",
    },
    {
      "label": "Ilocano",
      "value": "Ilocano",
    },
    {
      "label": "Inglês",
      "value": "Inglês",
    },
    {
      "label": "Iorubá",
      "value": "Iorubá"
    },
    {
      "label": "Italiano",
      "value": "Italiano",
    },
    {
      "label": "Japonês",
      "value": "Japonês",
    },
    {
      "label": "Javanês",
      "value": "Javanês",
    },
    {
      "label": "Jin",
      "value": "Jin",
    },
    {
      "label": "Khmer",
      "value": "Khmer",
    },
    {
      "label": "Kirundi",
      "value": "Kirundi",
    },
    {
      "label": "Madurês",
      "value": "Madurês",
    },
    {
      "label": "Magahi",
      "value": "Magahi",
    },
    {
      "label": "Maithili",
      "value": "Maithili",
    },
    {
      "label": "Malaiala",
      "value": "Malaiala",
    },
    {
      "label": "Malaio",
      "value": "Malaio",
    },
    {
      "label": "Malgaxe",
      "value": "Malgaxe",
    },
    {
      "label": "Mandarim",
      "value": "Mandarim",
    },
    {
      "label": "Marati",
      "value": "Marati",
    },
    {
      "label": "Marvari",
      "value": "Marvari",
    },
    {
      "label": "Min Bei",
      "value": "Min Bei",
    },
    {
      "label": "Min Dong",
      "value": "Min Dong",
    },
    {
      "label": "Min Nan",
      "value": "Min Nan",
    },
    {
      "label": "More",
      "value": "More"
    },
    {
      "label": "Nepalês",
      "value": "Nepalês"
    },
    {
      "label": "Oriá",
      "value": "Oriá"
    },
    {
      "label": "Oromo",
      "value": "Oromo",
    },
    {
      "label": "Panjabi",
      "value": "Panjabi",
    },
    {
      "label": "Pastó",
      "value": "Pastó",
    },
    {
      "label": "Persa",
      "value": "Persa",
    },
    {
      "label": "Polonês (Polaco)",
      "value": "Polonês (Polaco)"
    },
    {
      "label": "Português",
      "value": "Português",
    },
    {
      "label": "Português Brasil",
      "value": "Português Brasil",
    },
    {
      "label": "Quíchua",
      "value": "Quíchua",
    },
    {
      "label": "Quiniaruanda",
      "value": "Quiniaruanda",
    },
    {
      "label": "Romeno",
      "value": "Romeno",
    },
    {
      "label": "Russo",
      "value": "Russo",
    },
    {
      "label": "Seraiki",
      "value": "Seraiki",
    },
    {
      "label": "Serbo-croata",
      "value": "Serbo-croata",
    },
    {
      "label": "Sindi",
      "value": "Sindi",
    },
    {
      "label": "Somali",
      "value": "Somali",
    },
    {
      "label": "Sueco",
      "value": "Sueco",
    },
    {
      "label": "Sundanês",
      "value": "Sundanês",
    },
    {
      "label": "Sylheti",
      "value": "Sylheti",
    },
    {
      "label": "Tagalo",
      "value": "Tagalo",
    },
    {
      "label": "Tailandês",
      "value": "Tailandês"
    },
    {
      "label": "Tâmil",
      "value": "Tâmil",
    },
    {
      "label": "Tcheco (Checo)",
      "value": "Tcheco (Checo)",
    },
    {
      "label": "Telugo",
      "value": "Telugo",
    },
    {
      "label": "Turco",
      "value": "Turco",
    },
    {
      "label": "Turcomano",
      "value": "Turcomano",
    },
    {
      "label": "Ucraniano",
      "value": "Ucraniano",
    },
    {
      "label": "Uigur",
      "value": "Uigur",
    },
    {
      "label": "Urdu",
      "value": "Urdu",
    },
    {
      "label": "Usbeque",
      "value": "Usbeque",
    },
    {
      "label": "Vietnamita",
      "value": "Vietnamita",
    },
    {
      "label": "Wu(Xangainês)",
      "value": "Wu(Xangainês)",
    },
    {
      "label": "Xhosa",
      "value": "Xhosa",
    },
    {
      "label": "Xiang",
      "value": "Xiang",
    },
    {
      "label": "Yue(Cantonês)",
      "value": "Yue(Cantonês)",
    },
    {
      "label": "Zhuang",
      "value": "Zhuang",
    },
    {
      "label": "Zulu",
      "value": "Zulu",
    }
  ]
}